module.exports = __webpack_public_path__ + "static/media/arrowBackHome.fb40bb9b.svg";